<template lang="pug">
.btn-delete(@click="$emit('delete')")
  img(src="~assets/btn-delete.png")
  
</template>
<script>
export default {
  name: 'BtnDelete',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.btn-delete
  position: absolute
  width: pxToRem(70)
  height: pxToRem(70)
  //border-radius: pxToRem(15)
  //background-color: white
  top: pxToRem(10)
  right: pxToRem(-20)
  line-height: 0
  img
    width: 100%
    object-fit: contain
</style>
